<template>
  <div class="weapon-specifications__item">
    <!--    <p class="item-title"> -->
    <!--      {{ $t('Team') }} -->
    <!--    </p> -->

    <div class="f gap16">
      <button
        v-for="team in filters.teams"
        :key="team"
        v-tooltip="$t(`teams.${team}`)"
        :class="{ active: activeFilters.team === team }"
        class="item-labels-item btn btn-primary-stroke"
        @click="setFilter('team', team || '')"
      >
        <img
          :alt="team"
          :src="getImageFromProxy(getImage(team as string))"
          class="team-img"
        >
        <span
          v-if="activeFilters.team === team"
          class="item-labels-right"
        >
          <i class="i-times" />
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ItemWeaponPageFiltersResult } from '~/graphql/generated/schema-types';

defineProps<{ filters: ItemWeaponPageFiltersResult }>();
const route = useRoute();
const router = useRouter();

const activeFilters = computed(() => {
  return {
    team: route.query.team,
  };
});

function setFilter(name: string, value: string | null) {
  const newQuery = { ...route.query };

  if (value === null || value === newQuery[name]) {
    delete newQuery[name];
  } else {
    newQuery[name] = value;
  }

  router.push({ query: newQuery });
}

const terroristsImage = 'https://waxpeer.com/img/icon_t.webp';
const ctImage = 'https://waxpeer.com/img/icon_ct.webp';

function getImage(team: string) {
  if (team.toLowerCase() === 'terrorists') {
    return terroristsImage;
  }
  if (team.toLowerCase() === 'both') {
    return ctImage;
  }

  return ctImage;
}
</script>

<style scoped>
.item-labels {
  justify-content: center;
}

.team-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
</style>
